export const CART_KEY = 'promptsclub-cart';
export const CHECKOUT = 'promptsclub-checkout';
export const PRODUCTS_PER_PAGE = 30;
export const RTL_LANGUAGES: ReadonlyArray<string> = ['ar', 'he'];

export function getDirection(language: string | undefined) {
  if (!language) return 'ltr';
  return RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
}

interface Sortable {
  // id: number | string;
  // key: string;
  label: string;
  value: string;
  orderBy: string;
  sortedBy: 'ASC' | 'DESC';
}

export const sortables: Sortable[] = [
  {
    label: 'Popularity',
    value: 'popularity',
    orderBy: 'orders_count',
    sortedBy: 'DESC',
  },
  {
    label: 'New',
    value: 'new',
    orderBy: 'created_at',
    sortedBy: 'DESC',
  },
  {
    label: 'Old',
    value: 'old',
    orderBy: 'created_at',
    sortedBy: 'ASC',
  },
  {
    label: 'Rating',
    value: 'rating',
    orderBy: 'store_review_score',
    sortedBy: 'DESC',
  },
  // TODO: add price sorting?
  // TODO: add discount sorting?
  // TODO: add model version sorting?
];
